import { find } from '../../../utils/xp.v1'

export default {
  isLoaded(state) {
    return !!state.audioList
  },
  // 首个音频
  firstItem(state) {
    const { audioList } = state
    return audioList && audioList[0] ? audioList[0] : null
  },

  // playSwitch
  playSwitch(state) {
    return !!state.playState.playing
  },

  playProgress(state) {
    const { playState } = state
    const { time, duration } = playState

    return duration > 0 ? +(time / Math.max(duration, 60)).toFixed(4) : 0
  },

  playSeconds(state) {
    const { playState } = state
    const { time, duration } = playState

    return time > 0 ? Math.round(Math.min(time, duration)) : 0
  },

  // 当前播放的音频
  curOid(state) {
    return +state.playState.oid || 0
  },
  curItem(state) {
    const { audioList, curOid } = state

    const item =
      audioList && curOid > 0 ? find(audioList, (o) => o.oid === curOid) : null

    return item || null
  },

  // 往期回顾
  oldList(state) {
    const { audioList } = state
    return audioList ? audioList.slice(1) : []
  }
}
